import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import Container from 'packages/kakapo-ui-kit/components/grid/Container';

import FeedbackResponseComposer from './FeedbackResponseComposer';
import FeedbackRespondInstructions from './FeedbackRespondInstructions';
import FeedbackThankYou from './FeedbackThankYou';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import ExternalMenu from 'navigation/ExternalMenu';

function ExternalFeedbackResponseComposerContents(props: { responseID: string; secret: string }) {
	const response = graphql.useExternalFeedbackQuery({
		variables: {
			id: props.responseID,
			secret: props.secret,
		},
	});

	if (response.data) {
		return (
			<FeedbackResponseComposer
				response={response.data.externalFeedback as graphql.FeedbackResponse}
				secret={props.secret}
			/>
		);
	} else if (response.error) {
		return <FeedbackThankYou external />;
	} else {
		return <Spinner isLoading size="18px" />;
	}
}

export default function ExternalFeedbackResponseComposer(props: {
	responseID: string;
	secret: string;
}) {
	return (
		<Box>
			<ExternalMenu />
			<Container>
				<Flex justifyContent="center" flexWrap="wrap">
					<Column my={[4, 4, 5]} width={[1, 1, 6 / 12]} spaced>
						<ExternalFeedbackResponseComposerContents
							responseID={props.responseID}
							secret={props.secret}
						/>
					</Column>

					<Column width={[1, 1, 3 / 12]} p={[0, 0, 4]} pb={[4, 4, 0]} spaced>
						<FeedbackRespondInstructions />
					</Column>
				</Flex>
			</Container>
		</Box>
	);
}
